import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-we-got-your-application',
  templateUrl: './we-got-your-application.component.html',
  styleUrls: ['./we-got-your-application.component.scss']
})
export class WeGotYourApplicationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/we-got-your-application/we-got-your-application.component.ts